/**
 * Curfew report grid — filter→param builder.
 *
 * Turns the curfew report's customer scope and toolbar date range into the
 * EntityGrid `extraParams` object for odl-app/curfew-report/. This endpoint
 * serializes the range as a *local* calendar day (`date-fns` format), not
 * UTC, so the shared date-range helper is given a local serializer — the
 * reason `withDateRange` takes an injectable `serialize`.
 *
 * Contains:
 * - buildCurfewReportParams — customer + date range → extraParams
 */

import { format } from 'date-fns';

import { withDateRange } from '@sophocles/utils/queryParams';

/** Local calendar day — matches the curfew endpoint's date convention. */
const serializeLocalDate = date => format(date, 'yyyy-MM-dd');

/**
 * @param {Object} filters
 * @param {number} filters.customerId
 * @param {Date} filters.startDate
 * @param {Date} filters.endDate
 * @returns {Object} EntityGrid extraParams
 */
export const buildCurfewReportParams = ({ customerId, startDate, endDate }) =>
  withDateRange(
    { customer_id: customerId },
    {
      start: startDate,
      end: endDate,
      startKey: 'start_date',
      endKey: 'end_date',
      serialize: serializeLocalDate,
    },
  );
